import React from 'react';
import ReactDOM from 'react-dom/client';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';

import ProcessDetails from './ProcessDetails';
import ProcessDetailsTabState from './ProcessDetailsTabState';

export default class ProcessDetailsTabView extends BufferTabView<ProcessDetailsTabState> {
  reactRoot: ReactDOM.Root | null = null;

  override initialize(): void {
    this.listenTo(this.model, 'change:fileId', () => {
      this.render();
    });
  }
  override render(): this {
    const props = {
      processId: this.model.get('fileId'),
    };
    this.reactRoot = renderToDOM(
      <div className="react-tab-container">
        <ProcessDetails {...props} />
      </div>,
      this.el,
      this.reactRoot
    );
    return this;
  }

  override removeAsync(callback: () => void): this {
    unmountRootsAsync([this.reactRoot], () => {
      this.reactRoot = null;
      super.remove();
      callback();
    });
    return this;
  }
}

ProcessDetailsTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
